import React, { Component } from 'react';

import { toRoman } from 'roman-numerals';
import moment from 'moment';

import ModuleBlock from './components/ModuleBlock';

import './LearningRoadmap.scss';

class LearningRoadmap extends Component {
  render() {
    let Sessions = [
      ...this.props['student-report-data'].UpcomingSessions,
    ];
    Sessions.sort((a, b) => (new Date(a.scheduled_to)).getTime() - (new Date(b.scheduled_to)).getTime());

    return (
      <div className='student-report-learning-roadmap'>
        <div className='container'>
          <div className='row justify-content-md-center mobile-sticky'>
            <div className='col-md-8'>
              <div className='student-report-learning-roadmap__header-title'>
                <h2>Upcoming Sessions</h2>
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col'>
              {Sessions.map((entry, index) => (
                <div className='student-report-learning-roadmap-entry' key={index}>
                  <ModuleBlock module-block-data={entry} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default LearningRoadmap;



// WEBPACK FOOTER //
// ./src/routes/progress-report/routes/ProgressReport/components/ProgressReport/components/LearningRoadmap/index.js